import PriceItem from './PriceItem';
import Model from './Model';

export default class Article implements Model{

    private name:string;
    private prices: Array<PriceItem>;
    private isStarorder: Boolean;
    private number:string;
    private icon:string;
    private description:string;

    
	constructor($name: string, $prices: Array<PriceItem>, $isStarorder: Boolean, $number:string, $icon:string, $description:string) {
		this.name = $name;
		this.prices = $prices;
        this.isStarorder = $isStarorder;
        this.number = $number;
        this.icon = $icon;
        this.description = $description;
	}


    /**
     * Getter $icon
     * @return {string}
     */
	public get $icon(): string {
		return this.icon;
	}

    /**
     * Setter $icon
     * @param {string} value
     */
	public set $icon(value: string) {
		this.icon = value;
	}


    /**
     * Getter $number
     * @return {string}
     */
	public get $number(): string {
		return this.number;
	}


    /**
     * Getter $name
     * @return {string}
     */
	public get $name(): string {
		return this.name;
	}

    /**
     * Getter $prices
     * @return {Array<PriceItem>}
     */
	public get $prices(): Array<PriceItem> {
		return this.prices;
	}

    /**
     * Getter $isStarorder
     * @return {Boolean}
     */
	public get $isStarorder(): Boolean {
		return this.isStarorder;
    }
    

    /**
     * Setter $number
     * @param {string} value
     */
	public set $number(value: string) {
		this.number = value;
	}


    /**
     * Setter $name
     * @param {string} value
     */
	public set $name(value: string) {
		this.name = value;
	}

    /**
     * Setter $prices
     * @param {Array<PriceItem>} value
     */
	public set $prices(value: Array<PriceItem>) {
		this.prices = value;
	}

    /**
     * Setter $isStarorder
     * @param {Boolean} value
     */
	public set $isStarorder(value: Boolean) {
		this.isStarorder = value;
    }
    

    /**
     * Getter $description
     * @return {string}
     */
	public get $description(): string {
		return this.description;
	}

    /**
     * Setter $description
     * @param {string} value
     */
	public set $description(value: string) {
		this.description = value;
	}


}